module.exports = __webpack_public_path__ + "img/brush.svg";